import { useState } from "react";
import { HashLink } from 'react-router-hash-link';
import './Header.css';

import logoBosoTokyoWebp from '../img/logo-boso-tokyo.webp';
import logoBosoTokyo from '../img/logo-boso-tokyo.png';
import logoOpenseaWebp from '../img/logo-opensea.webp';
import logoOpensea from '../img/logo-opensea.png';
import logoDiscordWebp from '../img/logo-discord.webp';
import logoDiscord from '../img/logo-discord.png';
import logoTwitterWebp from '../img/logo-twitter.webp';
import logoTwitter from '../img/logo-twitter.png';
import menuIconOpen from '../img/icons/menu-icon-open.svg';
import menuIconClose from '../img/icons/menu-icon-close.svg';

import { Link } from "react-router-dom";

export default function Header() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const Menu = () => {
        return (
            <div className="Header__menu">
                <div className="Header__logo glitchPatternInfinite05">
                    <Link to="/">
                        <picture>
                            <source type="image/webp" srcSet={logoBosoTokyoWebp} />
                            <img src={logoBosoTokyo} alt="BoSo TOKYO ロゴ" />
                        </picture>
                    </Link>
                </div>
                <div className="Header__rightContainer">
                    <nav className="Header__nav">
                        <ul>
                            <li><Link to="/gallery">Gallery</Link></li>
                            <li><Link to="/revving">Revving</Link></li>
                            <li><HashLink to="/#about">About</HashLink></li>
                            <li><HashLink to="/#vision">Vision</HashLink></li>
                            <li><HashLink to="/#zoku">Zoku</HashLink></li>
                            <li><HashLink to="/#roadmap">RoadMap</HashLink></li>
                            <li><HashLink to="/#member">The Clan</HashLink></li>
                            <li><Link to="/rule" target="_blank">Rules</Link></li>
                        </ul>
                    </nav>

                    <div className="Header__icon">
                        <a href="https://opensea.io/collection/bosotokyo-official" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={logoOpenseaWebp} />
                                <img src={logoOpensea} alt="OpenSea link" />
                            </picture>
                        </a>
                    </div>
                    <div className="Header__icon glitchPatternInfinite03">
                        <a href="https://discord.gg/bosotokyo" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={logoDiscordWebp} />
                                <img src={logoDiscord} alt="Discord link" />
                            </picture>
                        </a>
                    </div>
                    <div className="Header__icon glitchPatternInfinite04">
                        <a href="https://twitter.com/BosoTokyo" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={logoTwitterWebp} />
                                <img src={logoTwitter} alt="Twitter link" />
                            </picture>
                        </a>
                    </div>

                    <div className="Header__menuBtn">
                        <button onClick={() => setIsModalOpen(!isModalOpen)}><img src={isModalOpen ? menuIconClose : menuIconOpen} alt="sp menu open" /></button>
                    </div>

                </div>
            </div>
        )
    }

    return (

        <>
            {isModalOpen ? (
                <header className="Header open" id="HeaderLogo">
                    <Menu />
                    <div className="Header__Modal">
                        <Menu />
                        <nav className="Header__nav--sp">
                            <ul>
                                <li><Link to="/gallery" onClick={() => setIsModalOpen(false)}>Gallery</Link></li>
                                <li><Link to="/revving" onClick={() => setIsModalOpen(false)}>Revving</Link></li>
                                <li><HashLink to="/#about">About</HashLink></li>
                                <li><HashLink to="/#vision">Vision</HashLink></li>
                                <li><HashLink to="/#zoku">Zoku</HashLink></li>
                                <li><HashLink to="/#roadmap">RoadMap</HashLink></li>
                                <li><HashLink to="/#member">The Clan</HashLink></li>
                                <li><Link to="/rule" target="_blank">Rules</Link></li>
                            </ul>
                        </nav>
                    </div>
                </header>

            ) : (
                <header className="Header" id="HeaderLogo">
                    <Menu />
                </header>
            )}
        </>

    );
}